import Icon from '../components/Icon.vue'

Icon.register({
  percent: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M112 224c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112zM112 64c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zM336 288c61.9 0 112 50.1 112 112s-50.1 112-112 112-112-50.1-112-112 50.1-112 112-112zM336 448c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM392.3 0.2l31.6-0.1c19.4-0.1 30.9 21.8 19.7 37.8l-366.2 463.7c-3.9 5.6-12.7 10.2-19.6 10.2l-33.4 0.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7c4.5-6.4 11.8-10.2 19.6-10.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/percent.js
// module id = null
// module chunks = 